'use strict'

module.exports = {
  OPEN: 'open',
  CLOSING: 'closing',
  CLOSED: 'closed'
}
